import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import {
  VerificationMethod,
  WithFailureProps,
} from '@app/store/transport-layer/types/verification';

interface DocumentsParticipantsVerificationCheckKeyStatusResponse {
  id: string;
  methods: WithFailureProps<
    VerificationMethod & { verificationKeyStatus: 'PENDING' | 'SUCCESS' }
  >[];
}

/**
 * GET 인증 키에 대한 인증 결과 및 상태 조회
 * Endpoint is declared on standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#f2f1fe99c33845f8a90066668a6cfcfb
 */
export function getDocumentsParticipantsVerificationCheckKeyStatus({
  verificationKey,
  documentId,
  participantId,
  workspaceId,
}: {
  verificationKey: string;
  documentId: string;
  participantId: string;
  workspaceId: string;
}): Promise<DocumentsParticipantsVerificationCheckKeyStatusResponse> {
  return requestApi<DocumentsParticipantsVerificationCheckKeyStatusResponse>({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/participants/${participantId}/verification/check-key-status`
    ),
    method: 'POST',
    credentials: true,
    data: {
      verificationKey,
    },
  }).then((response) => response.data);
}
